import { STRINGS } from './constant';

const { NAME } = STRINGS;

export const getIsAddressPosting = state => state[NAME].isAddressPosting;
export const getHasAddressBeenPosted = state => state[NAME].hasAddressBeenPosted;
export const getError = state => state[NAME].error;
export const getAddress = state => state[NAME].address;
export const getGuestSession = state => state[NAME].guestSession;
